import React, { useMemo } from 'react';
import classnames from 'classnames';

const Icon = ({
	icon,
	disabled,
	className,
	onClick
}) => {
	// Concat className with modifiers
	const cls = classnames(
		'material-icons-tw',
		disabled && 'cursor-not-allowed',
		className
	);

	return <i translate="no" className={cls} onClick={disabled ? null : onClick}>{icon}</i>;
};

export default Icon;
